import { PaginationType } from "../../Types/APITypes";
import API from "./API";

class AssociationRequestAPI extends API {
  static get_requests = (params?: {
    pagination?: PaginationType;
    type?: "parent_student" | "tutor_student";
    status?: "pending" | "accepted" | "rejected";
  }) => {
    const p = params?.pagination;
    const page = p?.current_page || 1;
    const per_page = p?.per_page || 10;
    const q = new URLSearchParams();
    q.set("page", String(page));
    q.set("per_page", String(per_page));
    if (params?.type) q.set("type", params.type);
    if (params?.status) q.set("status", params.status);
    return this.getRequest(`association-requests?${q.toString()}`, true);
  };

  static get_request = (id: number) => {
    return this.getRequest(`association-requests/${id}/show`, true);
  };

  static accept = (id: number) => {
    return this.patchRequest(`association-requests/${id}/accept`, {}, true);
  };

  static reject = (id: number) => {
    return this.patchRequest(`association-requests/${id}/reject`, {}, true);
  }
}

export default AssociationRequestAPI;
